import Vue from 'vue';
import moment from 'moment';
import 'moment-timezone';

Vue.filter('moment', (value, format) => {
  if (!value) {
    return '-';
  }
  if (typeof value === 'object' && typeof value.date !== 'undefined') {
    value = value.date;
  }
  format = format || 'DD MMM YYYY, HH:mm';
  let abbr = '';
  if (format.indexOf('zz') > -1) {
    abbr = 'UTC';
  }
  return `${moment(value).format(format)} ${abbr}`;
});

Vue.filter('momentLocal', (value, format) => {
  if (!value) {
    return '-';
  }
  if (typeof value === 'object' && typeof value.date !== 'undefined') {
    value = value.date;
  }
  format = format || 'DD MMM YYYY, HH:mm zz';
  let abbr = '';
  if (format.indexOf('zz') > -1) {
    abbr = moment.tz(moment.tz.guess()).format('zz');
  }
  return `${moment.utc(value).local().format(format)} ${abbr}`;
});

Vue.filter('internalCDN', (value) => {
  if (!value) {
    return value;
  }
  const url = new URL(value);
  if (process.env.NODE_ENV === 'staging') {
    // return url.protocol + '//cdn-internal-beta1.loyalfans.com' + url.pathname;
  }
  if (url.host.indexOf('cdn-lcm') > -1) {
    return value;
  }
  if (url.host.indexOf('lcm-cdn2') > -1) {
    return value;
  }
  // return url.protocol + '//internal-cdn2.loyalfans.com' + url.pathname;
});
Vue.filter('momentTime', (value, format) => moment(value, 'HH:mm:ss').format(format));
Vue.filter('momentAgo', (value) => moment(value).fromNow());

Vue.filter('percentage', (value) => `${parseFloat((value * 100).toFixed(1))}%`);

// Vue.filter('toPrice', (value, currency) => {
//   if (typeof currency === 'undefined') {
//     currency = '$';
//   }
//   if (typeof value === 'undefined' || value === null) {
//     return '-';
//   }
//   return `${currency}${parseFloat(value).toFixed(2)}`;
// });

Vue.filter('truncate', (value, length) => {
  if (!value || value.length < length) {
    return value;
  }

  return `${value.substring(0, length)}...`;
});

Vue.filter('beautify', (value) => {
  if (!value) {
    return value;
  }
  value = value.replace(/[_-]/g, ' ');
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('ucfirst', (value) => {
  if (!value) {
    return value;
  }
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('striphtml', (value) => {
  const div = document.createElement('div');
  div.innerHTML = value;
  return div.textContent || div.innerText || '';
});

Vue.filter('mapObject', (value, field) => {
  if (!value || !value.length) {
    return '-';
  }
  field = field || 'name';
  return value.map((item) => item[field]).join(', ');
});

Vue.filter('addHttp', (value) => {
  if (value.indexOf('http') > -1) {
    return value;
  }
  return `https://${value}`;
});

Vue.filter('toPrice', (value, currency) => {
  if (typeof currency === 'undefined') {
    currency = '$';
  }
  if (typeof value === 'undefined' || value === null) {
    return '-';
  }
  if (!(`${value}`).includes('e')) {
    value = +(`${Math.round(`${value}e+${2}`)}e-${2}`);
  } else {
    const arr = (`${value}`).split('e');
    let sig = '';
    if (+arr[1] + 2 > 0) {
      sig = '+';
    }
    value = +(`${Math.round(`${+arr[0]}e${sig}${+arr[1] + 2}`)}e-${2}`);
  }
  value = parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  // if (currency) {
  return `${currency}${value}`;
  // }
  // return value;
});

Vue.filter('pad', (value, size) => {
  value = value.toString()
  while (value.length < size) value = '0' + value
  return value
})
